import { render, staticRenderFns } from "./order-package-widget.vue?vue&type=template&id=9fe1628a&scoped=true"
import script from "./order-package-widget.vue?vue&type=script&lang=js"
export * from "./order-package-widget.vue?vue&type=script&lang=js"
import style0 from "./order-package-widget.vue?vue&type=style&index=0&id=9fe1628a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe1628a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/快电商/preview-qcommerce-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fe1628a')) {
      api.createRecord('9fe1628a', component.options)
    } else {
      api.reload('9fe1628a', component.options)
    }
    module.hot.accept("./order-package-widget.vue?vue&type=template&id=9fe1628a&scoped=true", function () {
      api.rerender('9fe1628a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/order-package-widget.vue"
export default component.exports